module.exports = __webpack_public_path__ + "static/media/line.547d8906.svg";